import gql from 'graphql-tag';
const TOP_BOTTOM_PANEL_REVEAL_ACTIVITY_FRAGMENT = gql `
  fragment TopBottomPanelRevealActivityFragment on TopBottomPanelRevealActivity {
    rounds {
      contentImage {
        id
        image {
          id
          src
        }
        imageId
      }
      id
      steps {
        blockId
        id
        text
      }
    }
  }
`;
export default TOP_BOTTOM_PANEL_REVEAL_ACTIVITY_FRAGMENT;
